// extracted by mini-css-extract-plugin
export default {"googleButton":"gYHh7kKpPgzCqHOEAc0o","continueWithGoogle":"aTPLviAxHbEDH4haAhTQ"};